// @ts-nocheck
import { connect } from 'react-redux'
import { getCarrierInsurance as getInsurance } from 'utils/actions/carrier'
import { openEditInsuranceDialog as editInsurance } from 'apps/carrier/utils/actions/insurance'
import AutomobileLiabilityComponent from './AutomobileLiability'
import CargoCoverageLiabilityComponent from './CargoCoverageLiability'
import DishonestyCoverageComponent from './DishonestyCoverage'
import GeneralLiabilityComponent from './GeneralLiability'
import InsuranceComponent from './Insurance'
import TrailerInterchangeCoverageComponent from './TrailerInterchangeCoverage'
import WorkersCompensationComponent from './WorkersCompensation'

export const Insurance = connect(
  ({ carrier: { carrierDetails }, carrierInsurance }) => ({
    carrierId: carrierDetails ? carrierDetails.id : undefined,
    ...carrierInsurance,
  }),
  { getInsurance, editInsurance }
)(InsuranceComponent)
const connectSubComponent = (component, dataKey) =>
  connect(({ carrierInsurance: { insurances } }) => (insurances || {})[dataKey] || {})(component)
export const AutomobileLiability = connectSubComponent(
  AutomobileLiabilityComponent,
  'automotiveInsurance'
)
export const GeneralLiability = connectSubComponent(GeneralLiabilityComponent, 'generalInsurance')
export const CargoCoverageLiability = connectSubComponent(
  CargoCoverageLiabilityComponent,
  'cargoInsurance'
)
export const TrailerInterchangeCoverage = connectSubComponent(
  TrailerInterchangeCoverageComponent,
  'trailerInterchangeInsurance'
)
export const DishonestyCoverage = connectSubComponent(
  DishonestyCoverageComponent,
  'dishonestyInsurance'
)
export const WorkersCompensation = connectSubComponent(
  WorkersCompensationComponent,
  'workersCompensationInsurance'
)
